module.exports = __webpack_public_path__ + "img/polling.4e655228.png";